<template>
  <div>
    <form @submit.prevent="addCampoFinal" autocomplete="off">
      <b-row>
        <b-col sm="5">
          Campos
          <fcc-select
            :options="lstTabelaDepara"
            v-model="lstPublicacaoChange"
            placeholder="Selecione"
            required
            labelField="camponovo"
          >
          </fcc-select>
        </b-col>
        <b-col sm="5">
          Campos mysql
          <fcc-select
            :options="lstMysql"
            v-model="lstMysqlChange"
            placeholder="Selecione o campo"
            labelField="coluna"
            required
            valueField="coluna"
            :clearable="false"
          >
          </fcc-select>
        </b-col>
        <b-col sm="2">
          <div class="buttonsPadraoModal">
            <button
              v-b-tooltip.hover
              type="submit"
              title="Adicionar"
              class="btn btn-light border shadow-sm ml-2 text-dark"
            >
              <font-awesome-icon icon="plus" size="lg" />
            </button>
          </div>
        </b-col>
      </b-row>
    </form>
    <b-row class="mt-3">
      <b-col sm="12">
        <fccTable
          striped
          hover
          :fields="fieldsMysql"
          :orderby="sortBy"
          :actions="actionsMysql"
          :items="lstTabelaDeparaEspeciais"
          responsive
          :porPage="itemPorPage"
          :titlePage="titlePage"
          :titlePDF="titlePage"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import store from '../../../store'
export default {
  data() {
    return {
      lstTabelaDeparaEspeciais: [],
      actionsMysql: [
        {
          button: true,
          funcaoButton: 'deleteCampoMysqlFinal',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      lstPublicacaoChange: '',
      lstMysqlChange: ''
    }
  },
  props: {
    lstMysql: Array,
    deparaItem: Object,
    lstTabelaDepara: Array,
    fieldsMysql: Array,
    sortBy: String,
    itemPorPage: String,
    titlePage: String
  },
  methods: {
    deleteCampoMysqlFinal(_, item) {
      this.callConfirm(this.mensagemExcluir, item.camponovo).then(() => {
        axios
          .delete(
            store.state.baseUrlGestaoForm +
              'TabelaDeParaPublicacaoComplementares/Excluir/' +
              item.id,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.$emit('listandoDepara', this.deparaItem)
            this.listaCampos(this.deparaItem.idpublicacao)
            this.callToast(this.mensagensUpdate.excluido)
            this.carregaTexto()
          })
          .catch((error) => {
            this.setErrorSystem(error)
          })
      })
    },
    addCampoFinal() {
      var lista = [
        {
          id: 0,
          idpublicacao: this.deparaItem.idpublicacao,
          camponovo: this.lstPublicacaoChange.camponovo,
          campomysql: this.lstMysqlChange
        }
      ]
      axios
        .post(
          store.state.baseUrlGestaoForm +
            'TabelaDeParaPublicacaoComplementares/AdicionarTabelaDeParaPublicacaoComplementares',
          lista,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.lstPublicacaoChange = ''
          this.lstMysqlChange = ''
          this.$emit('listandoDepara', this.deparaItem)
          this.listaCampos(this.deparaItem.idpublicacao)
          this.carregaTexto()
          this.callToast(this.mensagensUpdate.editado)
        })
        .catch((error) => {
          this.$root.$emit('bv::hide::modal', 'deparaFieldModal')
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    listaCampos(idpublicacao) {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          store.state.baseUrlGestaoForm +
            'TabelaDeParaPublicacaoComplementares/ListarTabelaDeParaPublicacaoComplementares/' +
            idpublicacao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstTabelaDeparaEspeciais = response.data

          this.carregaTexto()
        })
        .catch(this.setErrorSystem)
    }
  },
  mounted() {
    this.listaCampos(this.deparaItem.idpublicacao)
  }
}
</script>
